import { gql } from '@apollo/client';

const printReceiptMutation = gql`
  mutation PrintReceipt($receiptInput: ReceiptInput!) {
    printReceipt(receiptInput: $receiptInput) @client {
      status
    }
  }
`;

export default printReceiptMutation;
